
import 'FF/Core/Bootstrap';
import 'FF/Libraries/JQuery/Form';
import 'jquery-mobile/js/events/touch';

import Controller from 'FF/Controllers/Base/Controller';
import Message from 'FF/Models/Common/Message';
import FFEmbed from 'FF/Models/Common/FFEmbed';

export default class BaseController extends Controller {

    ready() {
        super.ready();
		
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        
        global.Message = new Message;
        global.FFEmbed = new FFEmbed;

        if (Json.frameworkEmbedMode) {
            global.Message.show({
                text: '您已開啟 framework embed mode<br>開發完成應執行『php ff framework:update』<br>避免未更新 framework 就執行 git push 動作',
                second: 600
            });
        }

        if (Json.frameworkIsTesting) {
            global.Message.show({
                text: '目前主機正在執行自動測試程序<br>這段期間執行的所有操作將會被進行回溯',
                second: 600
            });
        }
    }
}